import { useEffect } from 'react';
import { Platform } from 'react-native';
import * as Updates from 'expo-updates';
import { logger } from '@/lib/logger';

export function UpdateChecker() {
  const { isUpdateAvailable } = Updates.useUpdates();

  useEffect(() => {
    if (isUpdateAvailable) {
      // Download silently; expo-updates applies it on the next cold launch.
      // No prompt, no mid-session reload.
      Updates.fetchUpdateAsync().catch((error) => {
        logger.error(error, '[UpdateChecker] Failed to download OTA update');
      });
    }
  }, [isUpdateAvailable]);

  return null;
}

export function UpdateCheckerWrapper() {
  if (Platform.OS === 'web') {
    return null;
  }

  if (!__DEV__) {
    return <UpdateChecker />;
  }

  return null;
}
